(function () {
  function navigateMaskedLink(event) {
    const el = event.target.closest('.we-masked-link[data-href]');
    if (!el) return;
    const href = el.getAttribute('data-href');
    if (!href) return;

    event.preventDefault();
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
      window.open(href, '_blank', 'noopener');
    } else {
      window.location.assign(href);
    }
  }

  document.addEventListener('click', navigateMaskedLink);
  document.addEventListener('auxclick', navigateMaskedLink);
})();
